import { useRef } from 'react';
import { useSelector } from 'react-redux';

import { EXPERIMENT_VIEWED } from '../../constants/analytics-events';
import { ExperimentGroupVariations } from '../experiment/experiments';
import { useShippingVolumeCategory } from '../use-shipping-volume-category';
import { FeatureFlagDeclarations } from '../../feature-flags/feature-flag-declarations';
import Global from '../../store/global-selectors';
import { Segment } from '../../services/analytics-services/segment';
import { useFeatureFlag } from '../../feature-flags/hooks/use-feature-flag';

const SINGLE_LABEL_SELLER = 'SINGLE_LABEL_SELLER';

export const useTrackSingleLabelSellerExperiment = (areFeatureFlagsReady) => {
  const hasTracked = useRef(false);
  const { isSmallTrialer } = useShippingVolumeCategory();
  const isExperimentEnabled = useFeatureFlag(FeatureFlagDeclarations.enableSingleLabelSellerExperiment);
  const sellerId = useSelector(Global.selectSellerSellerId)?.toString();
  const userId = useSelector(Global.selectUserCurrentUserId);
  const shipmentsPerMonth = useSelector(Global.selectSellerShipmentsPerMonth);

  const variant = isExperimentEnabled ? ExperimentGroupVariations.VARIANT : ExperimentGroupVariations.CONTROL;

  // Only track once for small trialer users when flags are ready
  if (!areFeatureFlagsReady || hasTracked.current || !isSmallTrialer) {
    return;
  }

  Segment.trackEvent(EXPERIMENT_VIEWED, {
    experiment_id: SINGLE_LABEL_SELLER,
    group_variation: variant,
    seller_id: sellerId,
    user_id: userId,
    enrollment_date: new Date(),
    shipments_per_month: shipmentsPerMonth,
  });

  hasTracked.current = true;
};
